export default __webpack_public_path__ + "static/media/video-thumb.0a3af457.png";